import React from 'react';
import * as R from 'ramda';
// helpers/constants
import * as G from '../../../helpers';
import * as GC from '../../../constants';
// feature fleet/equipment-service
import EquipmentServiceReport from '../../fleet/equipment-service/components/report';
//////////////////////////////////////////////////

const Component = (props) => {
  const {
    isOpened,
    odometer,
    openModal,
    openLoader,
    fleetType,
    closeModal,
    closeLoader,
    configGroup,
    isReadOnlyMode,
    vehicleTypeGuid,
    primaryObjectGuid,
    primaryObjectBranchGuid,
    handleToggleFormGroupTable,
  } = props;

  const fleetProfileTypeTruck = R.equals(fleetType, 'truck');
  const entityGuidType = G.ifElse(fleetProfileTypeTruck, GC.FIELD_TRUCK_GUID, GC.FIELD_TRAILER_GUID);
  const documentTypeDropdownName = G.ifElse(fleetProfileTypeTruck, GC.TRUCK_DOCUMENT_TYPE, GC.TRAILER_DOCUMENT_TYPE);

  return (
    <EquipmentServiceReport
      isOpened={isOpened}
      odometer={odometer}
      openModal={openModal}
      entityType={fleetType}
      openLoader={openLoader}
      closeModal={closeModal}
      closeLoader={closeLoader}
      entityGuid={primaryObjectGuid}
      isReadOnlyMode={isReadOnlyMode}
      entityGuidType={entityGuidType}
      vehicleTypeGuid={vehicleTypeGuid}
      branchGuid={primaryObjectBranchGuid}
      handleToggleFormGroup={() => handleToggleFormGroupTable('equipmentServices')}
      documentTypeOptions={R.pathOr([], ['dropdownOptions', documentTypeDropdownName], configGroup)}
    />
  );
};

export const equipmentServiceSettings = {
  Component,
  groupName: 'equipmentServices',
};
